<template>
  <messenger-chat-message-layout
    direction="incomming"
    :message-time="message.messageTime"
  >
    <div
      v-if="senderName"
      class="font-weight-semi-bold mb-1 truncate"
    >
      {{ senderName }}
    </div>

    <span
      v-if="messageHtml"
      v-safe-html="messageHtml"
      class="break-word"
    />

    <messenger-chat-message-info-compensator
      v-if="!message.attachments.length"
      :message-time="message.messageTime"
    />

    <messenger-chat-message-attachments
      v-if="message.attachments.length"
      class="message-attachments"
      :attachments="message.attachments"
    >
      <template v-slot:message-info-compensator>
        <messenger-chat-message-info-compensator :message-time="message.messageTime" />
      </template>
    </messenger-chat-message-attachments>
  </messenger-chat-message-layout>
</template>

<script lang="ts" setup>
import MessengerChatMessageLayout from '@widgets/messenger/components/messages/MessengerChatMessageLayout.vue'
import type { MessengerIncomingMessageListItem } from '@widgets/messenger/types/chat/message'
import { useWidgetChatMessageText } from '@widgets/messenger/compositions/useWidgetChatMessageText'
import MessengerChatMessageInfoCompensator from '@widgets/messenger/components/messages/MessengerChatMessageInfoCompensator.vue'
import MessengerChatMessageAttachments from '@widgets/messenger/components/messages/MessengerChatMessageAttachments.vue'
import { computed } from '@/composition/vue/compositionApi'

const props = defineProps<{
  message: MessengerIncomingMessageListItem
}>()

const senderName = computed(() => {
  return [props.message.firstName, props.message.lastName].filter(Boolean).join(' ')
})

const { messageHtml } = useWidgetChatMessageText(() => props.message.text)
</script>

<style lang="scss" scoped>
.message-attachments:not(:first-child) {
  margin-top: 6px;
}
</style>
